import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import reportWebVitals from './reportWebVitals';
import { initSentry } from './observability';

initSentry();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // ErrorBoundary sits outside StrictMode so it catches errors from any render pass.
  // StrictMode double-invokes renders in development, which can surface false positives
  // inside the boundary itself if it were nested inside StrictMode.
  <ErrorBoundary>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </ErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
